import * as React from 'react';

function SvgIconFailed(props) {
  return (
    <svg width={80} height={80} xmlns="http://www.w3.org/2000/svg" {...props}>
      <g fill="none" fillRule="evenodd">
        <circle stroke="#E7E7E7" strokeWidth={5} cx={40} cy={40} r={37.5} />
        <path
          d="M39 52.5h3a1 1 0 011 1v3a1 1 0 01-1 1h-3a1 1 0 01-1-1v-3a1 1 0 011-1zM39 20h3a1 1 0 011 1v28a1 1 0 01-1 1h-3a1 1 0 01-1-1V21a1 1 0 011-1z"
          fill="#E7E7E7"
        />
      </g>
    </svg>
  );
}

export default SvgIconFailed;
